import React from 'react';

import { Stack } from '@atlaskit/primitives';

import { withErrorBoundary, Attribution } from '@confluence/error-boundary';
import { fg } from '@confluence/feature-gating';
import { ScreenEvent } from '@confluence/analytics';
import {
	SIDEBAR_DETAILS_PANEL_LOAD_EXPERIENCE,
	ExperienceSuccess,
} from '@confluence/experience-tracker';

import { AttributesSection } from './components/AttributesSection';
import { UserSection } from './components/UserSection';
import { PropertiesSection } from './components/PropertiesSection';
import { PageModeSection } from './components/PageModeSection';
import { ConnectionsSection } from './components/ConnectionsSection';

const DetailsPanelComponent = () => (
	<>
		<Stack testId="details-panel-body">
			<UserSection />
			{fg('confluence_frontend_page_mode_in_details_panel') && <PageModeSection />}
			<AttributesSection />
			<PropertiesSection />
			<ConnectionsSection />
		</Stack>
		<ExperienceSuccess name={SIDEBAR_DETAILS_PANEL_LOAD_EXPERIENCE} />
		<ScreenEvent name="detailsPanelScreen" id="detailsPanelScreen" />
	</>
);

export const DetailsPanelBody = withErrorBoundary({
	attribution: Attribution.COMMENTS,
})(DetailsPanelComponent);
